import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, Menu, Newspaper, FileText, LogOut, Home, BarChart3, SlidersHorizontal, Cable } from 'lucide-react';
import { Avatar } from './ui/avatar';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { clients } from '../lib/data';
const navSections = [{
  title: null,
  items: [{
    icon: Home,
    label: 'Panoramica',
    path: '/home'
  }, {
    icon: Newspaper,
    label: 'Rassegne',
    path: '/rassegne'
  }, {
    icon: BarChart3,
    label: 'Statistiche',
    path: '/statistics'
  }, {
    icon: FileText,
    label: 'Report',
    path: '/reports'
  }]
}, {
  title: 'CONFIGURAZIONE',
  items: [{
    icon: SlidersHorizontal,
    label: 'Algoritmo',
    path: '/settings/algorithm'
  }, {
    icon: Cable,
    label: 'Connettori',
    path: '/settings/connectors'
  }]
}];
export function MobileTopBar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const currentClient = clients.find(c => c.id === 'intrum') || clients[0];
  return <>
      <div className="md:hidden flex flex-col bg-card border-b border-border w-full flex-shrink-0 z-10" data-id="element-44">
        {/* Top row */}
        <div className="flex items-center justify-between px-3 h-14 gap-2" data-id="element-45">
          <div className="flex items-center gap-2 min-w-0 flex-1" data-id="element-46">
            <Button variant="ghost" size="icon" className="h-9 w-9 flex-shrink-0" onClick={() => setSidebarOpen(true)} data-id="element-47">
              <Menu className="h-5 w-5" data-id="element-48" />
            </Button>
          </div>

          <div className="flex items-center gap-1 flex-shrink-0" data-id="element-49">
            <Button variant="ghost" size="icon" className="h-9 w-9" data-id="element-50">
              <Search className="h-5 w-5 text-muted-foreground" data-id="element-51" />
            </Button>
            <Avatar className="h-8 w-8 flex-shrink-0" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/gMQpnDVF4sUMZFXw5c1pgV/kh4ijivu_400x400.jpg" alt="Marco C." className="w-full h-full object-cover rounded-full" data-id="element-53" />
            </Avatar>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar Sheet */}
      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen} data-id="element-54">
        <SheetContent side="left" className="w-[280px] p-0 flex flex-col" style={{
        backgroundColor: '#1A1F2E',
        borderRight: '1px solid rgba(255,255,255,0.08)',
        color: '#E0E0E0'
      }} data-id="element-55">
          <SheetHeader className="p-4 text-left" style={{
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-56">
            <SheetTitle className="font-logo text-[20px] tracking-wide" style={{
            color: '#FFFFFF'
          }} data-id="element-57">
              Esclapon & Co.
            </SheetTitle>
          </SheetHeader>

          {/* Client Selector */}
          <div className="px-4 py-3" style={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-58">
            <span className="text-[11px] uppercase tracking-wider mb-1.5 block" style={{
            color: '#8B95A5'
          }} data-id="element-59">
              Cliente selezionato:
            </span>
            <div className="flex items-center gap-2" data-id="element-60">
              <img src={currentClient.logo} alt={currentClient.name} className="max-w-[80px] max-h-[24px] object-contain object-left" style={{
              filter: 'brightness(0) invert(1)'
            }} data-id="element-61" />
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-auto p-2 space-y-4" data-id="element-62">
            {navSections.map((section, idx) => <div key={idx} data-id="element-63">
                {section.title && <div className="px-3 py-2 text-[11px] uppercase tracking-wider" style={{
              color: '#6B7585'
            }} data-id="element-64">
                    {section.title}
                  </div>}
                <div className="space-y-0.5" data-id="element-65">
                  {section.items.map(item => {
                const Icon = item.icon;
                const isActive = location.pathname.startsWith(item.path);
                return <Link key={item.path} to={item.path} onClick={() => setSidebarOpen(false)} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors" style={{
                  color: isActive ? '#FFFFFF' : '#8B95A5',
                  backgroundColor: isActive ? 'rgba(77,184,232,0.12)' : 'transparent'
                }} data-id="element-66">
                        <Icon className="h-4 w-4 flex-shrink-0" style={{
                    color: isActive ? '#4DB8E8' : 'inherit'
                  }} data-id="element-67" />
                        <span className="text-sm" data-id="element-68">{item.label}</span>
                      </Link>;
              })}
                </div>
              </div>)}
          </nav>

          <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-69" />

          {/* Logout */}
          <div className="p-4" data-id="element-70">
            <Link to="/" onClick={() => setSidebarOpen(false)} className="flex items-center gap-3 px-3 py-2 rounded-md transition-colors" style={{
            color: '#B85450'
          }} data-id="element-71">
              <LogOut className="h-4 w-4" data-id="element-72" />
              <span className="text-sm" data-id="element-73">Esci</span>
            </Link>
          </div>
        </SheetContent>
      </Sheet>
    </>;
}